import type { InjectionKey } from 'vue'

export type ToggleValue = string | number
export interface ToggleGroupCtx {
  selected: () => ToggleValue | null
  select: (v: ToggleValue) => void
  name: string
  disabled?: boolean
  changeOnHover?: boolean
}

export const ToggleGroupKey: InjectionKey<ToggleGroupCtx> = Symbol('ToggleGroup')
